import React from "react";
import styleClasses from "../../../../containers/order/order.module.scss";
import { ILabels } from "../../../../models/card";

const Labels: React.FC<ILabels> = (props) => {
  const {
    isItSubstitute,
    priceAlternateLabel,
    additionalPrice = 0,
    calories,
    price,
    remainingBase,
    showAdditionalPrice = false,
    count = 0,
    itemBase = 0,
    isCreateYourOwnItem,
  } = props;

  const showPriceAdjustment = () => {
    if (price && price > 0) {
      return `+$${price.toFixed(2)}`;
    } else {
      return isItSubstitute ? "Substitute" : "";
    }
  };

  // const showLabel = () => {
  //   if (priceAlternateLabel) {
  //     return <span >{priceAlternateLabel} </span>;
  //   } else {
  //     return showPriceAdjustment()
  //   }
  // }

  const ExtraPrice = () => {
    if (remainingBase > 0) {
      if (price <= remainingBase) {
        return 0;
      } else if (price - remainingBase > 0) {
        return price - remainingBase;
      }
    } else {
      return price;
    }
  };

  // const showPrice = ExtraPrice()

  // const additionalChargingPrice = showAdditionalPrice && count === 0 && showPrice > 0 ? true : false

  return (
    <h6
      className={`${styleClasses.item_detals} f-s10 font-rale d-flex justify-content-between mb-0 lh-normal text-nowrap`}
    >
      {calories > 0 && `${calories} cal`}

      {/* Below code is for testing purpose don't remove */}
      {/* {
        showAdditionalPrice ?
        <>
          <br/>
          {itemBase} itemBase
          <br/>
          {remainingBase} groupbase
          <br/>
          {price} price
          <br/>
          {showPrice && showPrice.toFixed(2)} next Price
        </>
        :null
      }
       */}
      {!isCreateYourOwnItem && additionalPrice > 0 && (
        <span className="text-danger font-Visby-cf f-w5 w-100 text-end" data-testid="counterCardPrice">
          +${additionalPrice.toFixed(2)}
        </span>
        // Uncomment the code below if you need to show additional labels or prices in the future.
        /*
  : (
    <span className='text-end d-block w-100 '>
      {showLabel()}
      {showAdditionalPrice && count === 0 && price > itemBase && (
        <span className="text-danger font-Visby-cf f-w5">+${(price - itemBase).toFixed(2)}</span>
      )}
      // For scenario checking (2nd use case)... keep the code below as needed
      {additionalChargingPrice && (
        <span className="text-danger font-Visby-cf f-w5">+${showPrice && showPrice.toFixed(2)}</span>
      )}
    </span>
  )
  */
      )}
    </h6>
  );
};

export default Labels;
